import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css'

const ReactCarousel = ({ children, ...props }: any) => (
  <>
    <Carousel {...props}>{children}</Carousel>
    <style jsx global>{`
      .carousel {
        padding: 4rem 0rem;
      }
      .carousel .control-dots {
        bottom: none !important;
        top: 29rem !important;
        margin-top: 6rem !important;
      }
      .carousel ul .dot {
        background: #d3d3d3 !important;
        box-shadow: none !important;
        width: 12px !important;
        height: 12px !important;
      }
      .carousel ul .dot.selected {
        background: #ff5a43 !important;
      }
      .carousel .slide {
        background: none;
      }

      .carousel .control-dots {
        display: flex;
        position: static;
        align-items: center;
        justify-content: center;
      }

      .video-carousel .carousel .control-dots {
        margin-top: 1rem !important;
      }

      .carousel .slide iframe {
        margin: 0;
        width: 100%;
      }

      #courses .carousel-slider,
      .panelist .carousel-slider {
        padding-top: 2rem !important;
        padding-bottom: 1rem !important;
      }

      #courses .control-dots,
      .panelist .control-dots {
        margin-top: 1.5rem !important;
      }

      #homepage_testimonials .control-dots,
      .panelist .control-dots {
        margin-top: 1.5rem !important;
      }
    `}</style>
  </>
)

export default ReactCarousel
